<template>
  <div class="height100">
    <TopMenu />
    <div class="view height100">
      <transition name="fade" appear>
        <div class="height100" style="overflow: hidden">
          <div class="p-4">
            <div class="input-group rounded">
              <div class="input-group-prepend">
                <span class="input-group-text rounded-left border-right-0 border-primary">
                  <span :style="{ display: requestRunning ? 'none' : 'block' }"><FontAwesomeIcon icon="search" /></span>
                  <span :style="{ display: !requestRunning ? 'none' : 'block' }"><FontAwesomeIcon icon="spinner" spin /></span>
                </span>
              </div>
              <input type="text" v-model="search" v-on:input="inputListener" :placeholder="$t('Search')" class="form-control rounded-right border-left-0 border-primary"></div>
          </div>
          <div v-if="songs != null" class="height100_scrollable_list" v-on:scroll="scrollHandler($event)">
            <SongsList :songs="displaySongs" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import musicboxClient from '@/utils/musicboxClient'
// import { ROUTE_DASHBOARD } from '@/const/routeNames'
import { secondsToMinAndSec } from '@/utils/numberUtils'
import scrollHandler from '@/utils/scrollHandler'
import audioManager from '@/utils/audioManager'
var timeoutTracker = null

export default {

  name: 'Addsongs',

  data () {
    return {
      search: '',
      songs: null,
      displayLimit: 30,
      requestRunning: false,
      preview: null,
      previewSongId: null,
      requestQueue: new Set()
    }
  },

  beforeDestroy () {
    if (this.preview != null) {
      this.preview.pause()
      this.preview = null
    }
  },

  computed: {
    displaySongs () {
      return this.songs.results.slice(0, this.displayLimit)
    },
    isPlaying () {
      return this.$store.state.audio.audioPlaying
    },
    isWebBox () {
      return this.$store.state.audio.currentBox.is_web
    }
  },

  methods: {

    scrollHandler: scrollHandler('songs.results'),

    handleAdd (song) {
      if (this.$route.query && this.$route.query.playlist === 'create') {
        this.$store.commit('updateEditedPlaylist', { key: 'songList', value: song })
        this.$notify.success(this.$t('Added {songTitle}', { songTitle: song.title }))
      } else {
        this.addToQueue(song)
      }
    },

    previewClick (song) {
      if (this.isPlaying || song.preview_url == null || song.preview_url === '') { return }
      if (this.previewSongId != null) {
        if (this.previewSongId === song.id) {
          this.preview.pause()
          this.preview = null
          this.previewSongId = null
        }
        return
      }
      this.preview = new Audio(song.preview_url)
      this.previewSongId = song.id
      this.preview.onended = () => {
        this.preview = null
        this.previewSongId = null
      }
      this.preview.play()
    },

    addToQueue (song) {
      const songId = song.id
      if (this.$store.state.audio.currentBox == null || this.requestQueue.has(songId)) { return }
      this.requestQueue.add(songId)
      this.requestQueue = new Set(this.requestQueue)
      musicboxClient
        .addSongToQueue(this.$store.state.audio.currentBox.uuid, { song_id: songId })
        .then(res => {
          // this.$router.push(ROUTE_DASHBOARD)
          this.$notify.success(this.$t('Enqueued {songTitle}', { songTitle: song.title }))
          audioManager.forceUpdateStatus()
        })
        .catch(e => {
          this.$notify.danger(this.$t('Failed to enqueue {songTitle}', { songTitle: song.title }))
        })
        .then(() => {
          this.requestQueue.delete(songId)
          this.requestQueue = new Set(this.requestQueue)
        })
    },

    inputListener () {
      if (timeoutTracker != null) { clearTimeout(timeoutTracker) }
      const searchTerm = this.search + ''
      timeoutTracker = setTimeout(() => {
        if (this.requestRunning) { return }
        this.requestRunning = true
        musicboxClient
          .searchSongs({ q: searchTerm })
          .then(res => {
            if (res.data) {
              res.data.results.forEach(song => {
                song.minutesAndSeconds = secondsToMinAndSec(song.duration)
              })
              this.songs = res.data
            }
          })
          .catch(e => {
            this.$notify.danger(this.$t('Search failed'))
          })
          .then(() => {
            this.requestRunning = false
          })
      }, 1000)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Addsongs.vue